import {
  fetchListPaymentWallet,
  fetchPaymentWallet,
  postNewPaymentWallet,
  deletePaymentWallet,
  updatePaymentWallet,
  resendConfirmationPayment,
  getAddressToCheck
} from "@/api/directWallet";

const state = {
  adaWallets: [],
  xpubWallets: [],
  ethWallets: [],
  xlmWallets: [],
  xrpWallets: []
};

const mutations = {
  UPDATE_DIRECT_XPUB_WALLETS(state, payload) {
    state.xpubWallets = payload;
  }
};

const actions = {
  fetchListPaymentWallet({ commit }, { query, coin }) {
    return new Promise((resolve, reject) => {
      fetchListPaymentWallet(query, coin)
        .then(response => {
          commit(`UPDATE_DIRECT_${coin}_WALLETS`, response.data);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchPaymentWallet({ commit }, id) {
    return new Promise((resolve, reject) => {
      fetchPaymentWallet(id)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  resendConfirmationPayment({ commit }, { id, coin }) {
    return new Promise((resolve, reject) => {
      resendConfirmationPayment(id, coin)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDirectPaymentAddressToCheck({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      getAddressToCheck(id)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deletePaymentWallet({ commit }, { id, coin }) {
    return new Promise((resolve, reject) => {
      deletePaymentWallet(id, coin)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updatePaymentWallet({ commit }, { data, coin }) {
    return new Promise((resolve, reject) => {
      updatePaymentWallet(data, coin)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  postNewPaymentWallet({ commit }, { data, coin }) {
    return new Promise((resolve, reject) => {
      postNewPaymentWallet(data, coin)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const wallet = {
  state,
  mutations,
  actions,
  getters: {
    getDirectWalletsByCoin: state => coin => {
      switch (coin) {
        case "XPUB":
          return state.xpubWallets;
        default:
          return [];
      }
    }
  }
};

export default wallet;
